import { render, staticRenderFns } from "./productList3.vue?vue&type=template&id=feae4432&scoped=true&"
import script from "./productList3.vue?vue&type=script&lang=js&"
export * from "./productList3.vue?vue&type=script&lang=js&"
import style0 from "./productList3.vue?vue&type=style&index=0&id=feae4432&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feae4432",
  null
  
)

export default component.exports